import { render, staticRenderFns } from "./MainMark.vue?vue&type=template&id=070672c4&scoped=true&"
import script from "./MainMark.vue?vue&type=script&lang=ts&"
export * from "./MainMark.vue?vue&type=script&lang=ts&"
import style1 from "./MainMark.vue?vue&type=style&index=1&id=070672c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070672c4",
  null
  
)

export default component.exports